import { ContactType } from '../../contact';
import { Entity } from '../../entity';
import { PriceListCategory, PricelistStatus } from '../../price.book';
import { PickerEntity } from './picker.entity';
import { EntityPagingInfo } from '../common';
import { ActivityEntityName, LabelType } from '../../shared';
import { JobTemplateMode } from '../../enums';
import { EntityViewFilter } from '../views';
import { EntityStatusType } from '../../entity.status';
import { UserType } from '../../tenant';
import { DocumentThemeScopeRequest } from '../../document.themes';
import { StockLocationType } from '../../equipment';

export type CrmPickerMode = 'Default' | 'SMS' | 'Email';

export interface PickerCrmRequest extends PickerRequest {
    types: ContactType[];
    mode?: CrmPickerMode;
    excludeIds?: string[];
    includeMe?: boolean;
    schedulingEnabled?: boolean;

    /** @description: For job legacy filter. It can get active:false. */
    includeDeleted?: boolean;

    relatedEntity?: {
        type: ActivityEntityName;
        id: string;
    }
}

export interface PickerSiteRequest extends PickerRequest {
    parentType?: ContactType[];
    excludeIds?: string[];
}

export interface PickerPriceListRequest extends PickerRequest {
    parentId: string;
    includeGlobal: boolean;
    status?: PricelistStatus;
    parentOnly?: boolean;
    category: PriceListCategory
}

export interface PickerDocumentThemeRequest extends PickerRequest {
    entity: ActivityEntityName;
    scope: DocumentThemeScopeRequest;
}

export interface PickerTagRequest extends PickerRequest {
    type: LabelType;
}

export interface PickerSecurityRoleRequest extends PickerRequest {
    types?: UserType[];
}

export interface PickerJobTemplateRequest extends PickerRequest {
    templateMode: JobTemplateMode;
    templateModes: JobTemplateMode[];
    scope?: 'Site' | 'Asset';
    serviceTypeId?: string;
    entity?: ActivityEntityName;
}

export type LegacyJobFilter = 'labels' | 'customers' | 'priceBooks' | 'billingCompanies' | 'workCategories' | 'jobTypes' | 'priorities' | 'zones' | 'owners' | 'fieldSupervisors' | 'resources' | 'statuses' | 'technicians' | 'employees' | 'claimTags' | 'finance';
export interface PickerLegacyJobRequest extends PickerRequest {
    viewId?: string;
    field?: LegacyJobFilter;
}

export enum PickerLoad {
    Eager = 'Eager',
    Lazy = 'Lazy',
}

export interface PickerRequest {
    search?: string;
    parentId?: string | string[];
    excludeIds?: string[];
    companyIds?: string[];
    page?: number;
    pageSize?: number;
    filters?: EntityViewFilter<any>[];
    addText?: string;
    fetch?: PickerLoad;
    itemTransform?: (item: any) => any;

    [key: string]: any;
    entityIds?: Record<ActivityEntityName, string | string[]>;
    variant?: string;
}

export interface PickerAutoCompleteRequest extends PickerRequest {
    // This the field in the document that will be turned into an autocomplete list
    fieldId: string;
}

export interface AutoSelectOptions {
    autoSelectCurrentUser?: boolean;
    autoSelectSingleCompany?: boolean;
}

export interface PickerEntityStatusRequest extends PickerRequest {
    entityType: ActivityEntityName;
    excludeIds?: string[];
    displayType?: EntityStatusType;
}

export interface PickerStockLocationRequest extends PickerRequest {
    type?: StockLocationType | StockLocationType[];
}
export interface ViewFilterRequest {
    viewId: string;
    fieldId: string;
    parentId?: string;
    search?: string;

    page?: number;
    pageSize?: number;
    filters?: EntityViewFilter[];
    [key: string]: any;
}

export interface PickerResponse<T extends Entity = PickerEntity> extends EntityPagingInfo {
    items: T[];
    hasColor?: boolean;
    hasAvatar?: boolean;
    bindDescription1?: string;
    bindDescription2?: string;
    bindDescription3?: string;
    bindTags?: string;
}

export interface PickerJobPolicyRequest extends PickerRequest {
    jobTypes: string[];
}

export interface PickerQuotePolicyRequest extends PickerJobPolicyRequest {
}

export function emptyPickerResult<T extends Entity = PickerEntity>(): PickerResponse<T> {
    return {
        page: 0,
        pageSize: 0,
        total: 0,
        items: []
    }
}
